import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "panel", "backdrop"]
  
  toggle() {
    const overlay = this.overlayTarget
    const panel = this.panelTarget
    const backdrop = this.backdropTarget
    
    if (overlay.classList.contains('hidden')) {
      this.open()
    } else {
      this.close()
    }
  }
  
  open() {
    const overlay = this.overlayTarget
    const panel = this.panelTarget
    const backdrop = this.backdropTarget
    
    // Show overlay
    overlay.classList.remove('hidden')
    
    // Animate in
    requestAnimationFrame(() => {
      backdrop.classList.remove('opacity-0')
      backdrop.classList.add('opacity-50')
      panel.classList.remove('-translate-x-full')
      panel.classList.add('translate-x-0')
    })
    
    // Prevent body scroll
    document.body.style.overflow = 'hidden'
  }
  
  close() {
    const overlay = this.overlayTarget
    const panel = this.panelTarget
    const backdrop = this.backdropTarget
    
    // Animate out
    backdrop.classList.remove('opacity-50')
    backdrop.classList.add('opacity-0')
    panel.classList.remove('translate-x-0')
    panel.classList.add('-translate-x-full')
    
    // Hide after animation
    setTimeout(() => {
      overlay.classList.add('hidden')
      document.body.style.overflow = ''
    }, 300)
  }
  
  connect() {
    // Close on escape key
    this.keydownHandler = (event) => {
      if (event.key === 'Escape' && !this.overlayTarget.classList.contains('hidden')) {
        this.close()
      }
    }
    document.addEventListener('keydown', this.keydownHandler)
  }
  
  disconnect() {
    document.removeEventListener('keydown', this.keydownHandler)
    document.body.style.overflow = ''
  }
}